import {OnClientAdd, OnClientDelete, OnClientUpdate} from "../Delegates/ClientDelegate.js";
import {OnProjetAdd, OnProjetDelete, OnProjetUpdate} from "../Delegates/ProjetDelegate.js";
import {IClientModel} from "../Model/Client/ClientModel.js";
import {IProjetModel} from "../Model/Projet/ProjetModel.js";
import {ClientRead} from "../Controller/Client/ClientRead.js";
import {IProjetFilterModel} from "../Model/FilterModel/ProjetFilterModel.js";
import {String} from "../Tools/Misc.js"
import {Projet} from "../Controller/Projet/ProjetRead.js";
import {KendoTreeviewTool} from "../Tools/KendoTreeviewTool.js";
import {Config} from "../config/Config.js";
import {ControlerList} from "../Tools/Circular.Object.js";
import {IDisposableLike} from "../Tools/Disposable/IDisposableLike";
import {ClientCreate} from "../Controller/Client/ClientCreate";
import {ProjetCreateController} from "../Controller/Projet/ProjetCreate";

export class MainMenu implements IDisposableLike {
    #index: KendoTreeviewTool = new KendoTreeviewTool();
    readonly #jqMainContainer: JQuery | undefined;
    #jqContainer: JQuery | undefined;
    #jqTool: JQuery | undefined;
    #kToolBar: kendo.ui.ToolBar | undefined;
    #jqTv: JQuery | undefined;
    #kTv: kendo.ui.TreeView | undefined;

    constructor(options: IMainMenuOption) {
        this.#jqMainContainer = options.jqMainContainer;
        this.#_init();
    }

    #_init = () => {
        this.#bindEvent().then();
        this.#buildHtml();
        this.#buildToolBar().then();
        this.#buildKendoTreeView().then();
    }

    #bindEvent = async () => {

        // Ajout d'un client : insère le nœud en tête d'arbre et le sélectionne.
        OnClientAdd.Bind((model: IClientModel) => {
            const firstNode = this.#kTv.element.find("li:first");
            this.#kTv.select(firstNode);

            const newNode = {
                text: model.RaisonSociale,
                circUrl: "/client?id=" + model.Primarykey,
                iconClass: "fa-regular fa-bars-progress",
                items: []
            };
            const appenedNode = this.#kTv.append(newNode, firstNode);
            this.#dealWithIcon().then();
            this.#index.Index(this.#kTv.dataSource, "circUrl").then();
            this.#kTv.select(appenedNode);
            this.#kTv.trigger("select", { node: appenedNode[0] });
        }, "mainMenu");

        // Ajout d'un projet : insère le nœud sous le client sélectionné.
        OnProjetAdd.Bind((model: IProjetModel) => {
            const selectedNode = this.#kTv.select();
            const newNode = {
                text: model.Nom,
                circUrl: "/projet?id=" + model.Primarykey,
                iconClass: "fa-regular fa-bars-progress",
                items: []
            };
            const appenedNode = this.#kTv.append(newNode, selectedNode);
            this.#kTv.select(appenedNode);
            this.#kTv.trigger("select", { node: appenedNode[0] });
            this.#index.Index(this.#kTv.dataSource, "circUrl").then();
            this.#dealWithIcon().then();
        }, "mainMenu");

        OnClientUpdate.Bind((model: IClientModel) =>
            this.#updateTree("/client?id=" + model.Primarykey, model.RaisonSociale), "mainMenu");

        OnProjetUpdate.Bind((model: IProjetModel) =>
            this.#updateTree("/projet?id=" + model.Primarykey, model.Nom), "mainMenu");
        
        OnProjetDelete.Bind((model: IProjetModel) => {
            const s = this.#kTv.select();
            const parentNode = s.parent();
            
            this.#kTv.remove(s);
            this.#kTv.select(parentNode);
            this.#kTv.trigger("select", { node: parentNode[0] });
        })
        
        OnClientDelete.Bind((model: IClientModel) => {
            const s = this.#kTv.select();
            this.#kTv.remove(s);

            const firstNode = this.#kTv.element.find("li:first");
            this.#kTv.select(firstNode);
            this.#kTv.trigger("select", { node: firstNode[0] });
            this.#index.Index(this.#kTv.dataSource, "circUrl").then();

        }, "mainMenu");
    }

    #buildClient = async () => {
        console.log("Is Super Admin", Config.ConnectedUser.IsSuperAdmin);
        if (!Config.ConnectedUser.IsSuperAdmin)
            return [];

        const c = await ClientRead.Read({
            AsNoTracking: true,
            IncludeProfilMail: false,
        });

        const ds = [
            {text: "Clients", iconClass: "fa-regular fa-industry-windows", items: []}
        ]

        ds[0].items = c.map(x => {
            return {
                text: x.RaisonSociale,
                circUrl: `/client?id=${x.Primarykey}`,
                iconClass: "fa fa-handshake",
                items: []
            }
        });
        
        return ds;
    }

    #buildDataSource = async () => {
        return await this.#buildClient();
    }

    #buildHtml = () => {
        this.#jqContainer = $("<div></div>")
            .appendTo(this.#jqMainContainer)
            .css({height: "100%", width: "100%", margin: 0, padding: 0, display: "flex", flexDirection: "column"});

        this.#jqTool = $("<div></div>")
            .appendTo(this.#jqContainer)
            .css({width: "100%", height: "36px"});


        this.#jqTv = $("<div id='mainMenu'></div>")
            .css({marginTop: "15px"})
            .css({display: "flex", flexGrow: "1"})
            .appendTo(this.#jqContainer);
    }

    #buildKendoTreeView = async () => {
        const ds = await this.#buildDataSource()
        console.dir(ds)
        this.#kTv = this.#jqTv.kendoTreeView({
            dataSource: new kendo.data.HierarchicalDataSource({data: ds}),
            dataSpriteCssClassField: "iconClass",
            animation: false,
            size: "medium",
            dataBound: (e: kendo.ui.TreeViewDataBoundEvent) => {
                e.sender.expand(e.sender.element.find("li:first"));
            },
            select: async (e: kendo.ui.TreeViewSelectEvent) => {
                const item = e.sender.dataItem(e.node);
                const url = item.get("circUrl");
                
                console.log(url);
                
                if (String.IsNullOrEmpty(url)) {
                    ControlerList.Instance.Navigate("/Home/Index").then();
                    return;
                }

                if (url.startsWith("/client?id=")) {
                    this.#buildProjet(item).then();
                    ControlerList.Instance.Navigate(url).then();
                    return;
                }

                if (url.startsWith("/projet?id=")) {
                    console.log(url);
                    ControlerList.Instance.Navigate(url).then();
                }


            }
        }).data("kendoTreeView");

        this.#index.Index(this.#kTv.dataSource, "circUrl").then();
        this.#dealWithIcon().then();
    }

    #buildToolBar = async () => {
        this.#kToolBar = this.#jqTool.kendoToolBar({
            size: "small",
            items: [
                {
                    type: "splitButton", text: "Ajouter", icon: "plus",
                    menuButtons: [
                        {
                            text: "Client",
                            icon: "handshake",
                            spriteCssClass: "fa fa-handshake",
                        },
                        {
                            text: "Projet",
                            icon: "bars-progress",
                            spriteCssClass: "fa-regular fa-bars-progress",
                        }
                    ]
                }
            ],
            click : (e: kendo.ui.ToolBarClickEvent) => this.#toolbarClick(e)
        }).data("kendoToolBar");
        
        this.#dealWithIcon().then();
    }

    #buildProjet = async (node: kendo.data.Node) => {
        const clientId = node.get("circUrl").split("?")[1].split("=")[1];
        const filter: IProjetFilterModel = {
            AsNoTracking: true,
            FkClient: clientId
        }
        const projets = await Projet.Read(filter);
        const children = projets.map(x => {
            return {
                text: x.Nom,
                circUrl: "/projet?id=" + x.Primarykey,
                iconClass: "fa-regular fa-bars-progress",
                items: []
            }
        })

        const li = this.#kTv.findByUid(node.uid);
        li.children("ul").find("li").remove();
        this.#kTv.append(children, li);
        this.#index.Index(this.#kTv.dataSource, "circUrl").then();
        this.#dealWithIcon().then();

    }

    #dealWithIcon = async () => {
        
        $("[data-role='buttonmenu'] .k-sprite")
            .removeClass("k-sprite")
        
        if (this.#kTv == null)
            return;
        
        this.#kTv.element.find(".k-sprite")
            .removeClass("k-sprite")
            .css("marginRight", "5px")
            .css("marginLeft", "-5px");
    }
    
    #toolbarClick = (e: kendo.ui.ToolBarClickEvent) => {
        switch (e.target.index()) {
            case 0:
                this.#addClient().then();
                break;
            case 1:
                this.#addProjet().then();
                break;
            default: 
                throw new Error("Unexpected value: " + e.target.index());
        }
    }

    #updateTree = async (pattern: string, value: string) => {
        const node = this.#index.Get(pattern);
        this.#kTv.findByUid(node.uid)
            .find("span.k-treeview-leaf-text")
            .text(value);
    }
    
    #addClient = async () => {
        // La raison sociale est demandée d'emblée : elle détermine le login du
        // compte de service créé avec le client (ex. cloture_en_ligne_service).
        const raisonSociale = await new Promise<string | null>(resolve =>
            kendo.prompt("Raison sociale du nouveau client :", "")
                .then((value: string) => resolve(value), () => resolve(null)));
        if (!raisonSociale?.trim())
            return;

        // L'insertion du nœud est prise en charge par l'abonnement à
        // OnClientAdd (cf. #bindEvent), déclenché par ClientCreate.
        await ClientCreate.Create(raisonSociale.trim());
    }
    
    #addProjet = async () => {
        const selectedNode = this.#kTv.select();
        
        if (selectedNode == null || !selectedNode.length) {
            kendo.alert("Aucun client n'est sélectionné.");
            return;
        }
        
        const item = this.#kTv.dataItem(selectedNode);
        console.dir(item);
        const circUrl = item.get("circUrl");
        console.log(circUrl);
        
        if (String.IsNullOrEmpty(circUrl) || !circUrl.startsWith("/client?id=")) {
            kendo.alert("Aucun projet n'est sélectionné.");
            return;
        }
        
        const clientId = circUrl.split("id=")[1];

        // L'insertion du nœud (sous le client sélectionné) est prise en charge
        // par l'abonnement à OnProjetAdd (cf. #bindEvent), déclenché par
        // ProjetCreateController.
        await ProjetCreateController.Create(clientId);
    }

    public Dispose = async () => {
        await OnClientUpdate.Clear("mainMenu");
        await OnClientAdd.Clear("mainMenu");
        await OnClientDelete.Clear("mainMenu");

        await OnProjetUpdate.Clear("mainMenu");
        await OnProjetAdd.Clear("mainMenu");
        await OnProjetDelete.Clear("mainMenu");
        
        console.log("MainMenu disposed");

        this.#kToolBar.destroy();
        this.#kTv.destroy();

        this.#jqMainContainer.empty();
        
    }
}

export interface IMainMenuOption {
    jqMainContainer: JQuery;
}